<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">Información del Rubro</div>
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'interesBancarioRubro/getField',
  mutationType: 'interesBancarioRubro/updateField',
});

export default {
  name: 'InteresesBancariosRubrosABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'inactivo',
    ])
  },  
  created() {
    let interesBancarioRubroId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        interesBancarioRubroId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('interesBancarioRubro/inicializar', interesBancarioRubroId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del rubro.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('interesBancarioRubro/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "InteresesBancariosRubros" });
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
